import DivLoader from "components/divloader/DivLoader";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { checkPaymentStatus, updateTestPaymentStatus } from "api/clients";
import toast from 'react-hot-toast';

function CompletePayment() {
  const { internal_tx_id } = useParams();
  const [initialLoading, setInitialLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isLinkUsed, setIsLinkUsed] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [transactionResult, setTransactionResult] = useState<any>(null);
  const [isReturnUrl, setIsReturnUrl] = useState(false);

  const fetchData = async () => {
    try {
      const data = { internal_tx_id };
      const checkLinkResponse = await checkPaymentStatus(data);
      setIsLinkUsed(checkLinkResponse.is_link_used);
    } catch (error) {
      console.error(error);
    } finally {
      setInitialLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [internal_tx_id]);

  const handleSubmit = async (e: any) => {
    setLoading(true);
    e.preventDefault();
    if (!selectedOption) {
        setLoading(false)
        toast.error("Please select an option before submitting!")
        return;
    }

    const data = {
      internal_tx_id,
      status: selectedOption,
    };
    const checkStatus = await updateTestPaymentStatus(data);

    if (checkStatus?.data?.transaction) {
      setTransactionResult(checkStatus.data.transaction);
      setLoading(false);
      if(checkStatus?.data?.transaction?.previous_return_url) {
        setIsReturnUrl(true)
        setTimeout(() => {
            window.location.href = checkStatus?.data?.transaction?.previous_return_url;
        }, 5000);
      }
    }
  };

  const getStatusColor = (code: string) => {
    switch (code) {
      case "APPROVED":
        return "text-green-600 bg-green-100";
      case "DECLINED":
      case "FAILED":
      case "ERRORED":
      case "REJECTED":
        return "text-red-600 bg-red-100";
      default:
        return "text-gray-600 bg-gray-100";
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
      {initialLoading ? (
        <div className="text-center">
          <DivLoader className="m-5 h-8 w-8 border-indigo-500" />
          <p className="text-gray-600">Loading, please wait...</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-md">
          {isLinkUsed ? (
            <div className="text-center">
              <h2 className="text-xl font-semibold text-red-600 mb-2">
                The Link Already Used!!
              </h2>
              <p className="text-gray-500">
                This payment link has expired or already been processed.
              </p>
            </div>
          ) : transactionResult ? (
            // ✅ Transaction Result Block
            <div className="space-y-4 text-center">
              <h2
                className={`text-xl font-semibold p-2 rounded-lg ${getStatusColor(
                  transactionResult.code
                )}`}
              >
                Payment {transactionResult.code}
              </h2>
              <div className="text-sm text-gray-600 space-y-1">
                <p>
                  <span className="font-medium">Transaction ID:</span>{" "}
                  {transactionResult.transactionID}
                </p>
                <p>
                  <span className="font-medium">Amount:</span>{" "}
                  {transactionResult.amount} {transactionResult.currency}
                </p>
                <p>
                  <span className="font-medium">Date:</span>{" "}
                  {transactionResult.date}
                </p>
                {transactionResult.errorMessage && (
                  <p className="text-red-600">
                    {transactionResult.errorMessage}
                  </p>
                )}
                {isReturnUrl ? (
                    <p className="text-slate-300 mt-4">
                        Redirecting to return url..........
                    </p>
                ) : null}
              </div>
            </div>
          ) : (
            // ✅ Show form if no transaction yet
            <>
              <h2 className="text-xl font-semibold text-center mb-4">
                Complete Your Payment
              </h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label
                    htmlFor="paymentOption"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Select Payment Status
                  </label>
                  <select
                    id="paymentOption"
                    value={selectedOption}
                    onChange={(e) => setSelectedOption(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg p-2 focus:ring-indigo-500 focus:border-indigo-500"
                  >
                    <option value="">-- Choose an option --</option>
                    <option value="APPROVED">Approved</option>
                    <option value="DECLINED">Declined</option>
                    <option value="FAILED">Failed</option>
                    <option value="ERRORED">Errored</option>
                    <option value="REJECTED">Rejected</option>
                  </select>
                </div>

                <button
                  type="submit"
                  className="w-full bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition"
                >
                  {loading ? (
                    <DivLoader className="h-6 w-6 border-white" />
                ) : (
                    <>
                    Submit
                    </>
                )}
                </button>
              </form>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default CompletePayment;
